/*
 * Parse an add_table `values` grid that may mix plain strings and styled cell
 * objects ({text, fill, color, bold, align}) — pure, unit-tested. Office.js
 * addTable stringifies a non-string cell to "[object Object]", so the object
 * form must be split into a text grid (for `values`) and a per-cell style grid
 * (applied via specificCellProperties) HERE, before it reaches Office.js.
 */
export interface CellStyle {
  fill?: string;
  color?: string;
  bold?: boolean;
  align?: "left" | "center" | "right";
}

export interface ParsedTable {
  text: string[][];
  styles: (CellStyle | undefined)[][];
}

export function parseTableValues(raw: any): ParsedTable {
  const rows: any[] = Array.isArray(raw) ? raw : [];
  const text: string[][] = [];
  const styles: (CellStyle | undefined)[][] = [];
  for (const row of rows) {
    const cells: any[] = Array.isArray(row) ? row : [row];
    const tRow: string[] = [];
    const sRow: (CellStyle | undefined)[] = [];
    for (const c of cells) {
      if (c !== null && typeof c === "object") {
        tRow.push(String((c as any).text ?? ""));
        const st: CellStyle = {};
        if ((c as any).fill != null) st.fill = String((c as any).fill);
        if ((c as any).color != null) st.color = String((c as any).color);
        if ((c as any).bold != null) st.bold = Boolean((c as any).bold);
        if ((c as any).align != null) st.align = (c as any).align;
        sRow.push(Object.keys(st).length ? st : undefined);
      } else {
        tRow.push(String(c ?? ""));
        sRow.push(undefined);
      }
    }
    text.push(tRow);
    styles.push(sRow);
  }
  return { text, styles };
}
